import { render, staticRenderFns } from "./results-pagination.vue?vue&type=template&id=cdfd4cc0&scoped=true"
import script from "./results-pagination.vue?vue&type=script&lang=js"
export * from "./results-pagination.vue?vue&type=script&lang=js"
import style0 from "./results-pagination.vue?vue&type=style&index=0&id=cdfd4cc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdfd4cc0",
  null
  
)

export default component.exports